<template>
  <div class="mockup-select-material" v-if="formatted">
    <div class="mockup-select-material__header">
      <input
        class="mockup-select-material__header-input"
        type="text"
        v-model="item"
        placeholder="Material"
        @input="changeAutoComplete(true)"
        @focusin="changeAutoComplete(true)"
        @focusout="changeAutoComplete(false)"
      />
      <div
        class="mockup__btn-icon mockup__btn-icon--active"
        @click="item === '' ? null : $emit('output', item)"
      >
        <icon-pencil />
      </div>
    </div>

    <ul
      class="mockup-select-material-items"
      v-show="autocomplete && !!formatted.length"
    >
      <li
        class="mockup-select-material-item"
        v-for="option in formatted"
        :key="option"
        @click="setItem(option)"
      >
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
import { getMaterials } from "@/api/factory-api/material-api/material.api.js";
import IconPencil from "@gocasebr/go-shared/dist/pencil/Pencil";

export default {
  components: { IconPencil },
  data() {
    return {
      item: "",
      items: null,
      autocomplete: false,
    };
  },
  computed: {
    formatted() {
      if (!this.items) return [];
      if (!this.item) return this.items;
      return this.items.filter((m) => m.includes(this.item));
    },
  },
  methods: {
    changeAutoComplete(value) {
      setTimeout(() => (this.autocomplete = value), 200);
    },
    setItem(item) {
      this.item = item;
      this.$emit("input", item);
      this.autocomplete = false;
    },
  },
  mounted() {
    getMaterials().then((res) => (this.items = res.map((r) => r.code)));
  },
};
</script>

<style lang="scss" scoped>
.mockup-select-material {
  position: relative;
  background: #fff;

  .mockup-select-material__header {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    padding: 6px;
    gap: 6px;

    &-input {
      padding: 5px 3px;
      border-radius: 5px;
      border: 1px solid #ec8ab3;
    }
  }

  .mockup-select-material-items {
    position: absolute;
    top: 35px;
    height: 300px;
    overflow: auto;
    width: calc(100% - 12px - 33px - 6px);
    list-style: none;
    padding: 6px 12px;
    background: #fff;
    z-index: 11;
    box-shadow: 0px 2px 7px -1px #999;
    border-radius: 5px;
    margin: 0 6px;

    .mockup-select-material-item {
      cursor: pointer;
      &:hover {
        background: rgba($color: #000000, $alpha: 0.5);
      }
    }
  }
}
</style>
